<div
    [classList]="[appMain.isDesktop() ? 'topbar flex justify-content-between align-items-center' : 'flex-wrap w-full']">

    <div [classList]="[appMain.isMobile ? 'topbar w-full flex align-items-center' : 'flex align-items-center']">
        <p-button icon="pi pi-chevron-left" size="small" text severity="contrast" 
            label="retour" (onClick)="goBack()">
        </p-button>
        <p-breadcrumb class="max-w-full" [model]="items" [home]="home" />
    </div>

    <div [classList]="[appMain.isMobile ? 'topbar w-full' : '']">
        <div class=""
            [classList]="[appMain.isMobile ? 'flex justify-content-around align-items-center gap-2 flex-wrap' : 'flex justify-content-end align-items-center gap-2']">
            <p-messages *ngIf="estEnModeImitation" severity="warn" [closable]="false">
                <ng-template pTemplate>
                    <div class=" flex align-items-center justify-content-between flex-wrap gap-2">
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-user-edit text-lg"></i>
                            <span class="font-semibold">Imitation rôles:</span>
                            <span>{{nomEmployeImite}}</span>
                        </div>
                        <p-button icon="pi pi-times" label="Retour au mode normal" severity="danger" text size="small"
                            (onClick)="arreterImpersonation()" [class]="appMain.isMobile ? 'w-full' : ''">
                        </p-button>
                    </div>
                </ng-template>
            </p-messages>
            @if (afficherAlerteDev) {
                <p-tag
                    icon="pi pi-exclamation-triangle"
                    value="Environnement de test"
                    styleClass="environnement-test-tag">
                </p-tag>
            }
            <p-button class="topbar-button" (onClick)="appMain.onSearchClick($event)" icon="pi pi-search" [text]="true"
                pTooltip="Rechercher" severity="contrast" />
            <div>
                <p-overlayPanel #fav>
                    <ng-template pTemplate="content">
                        <h6 class="m-0 font-bold">Favoris</h6>
                        <hr class="mt-0 mb-1">
                        <p-table [value]="favoris" [style]="{'min-width': '400px'}">
                            <ng-template let-favori pTemplate="body">
                                <tr>
                                    <td class="flex align-items-center p-2">
                                        <i class="pi pi-heart"></i>
                                        <div pButton severity="secondary" [text]="true" (click)="naviguer(favori.url)"
                                            class="ml-2">{{favori.description}}</div>
                                        <div style="margin-left: auto;">
                                            <p-button severity="secondary" [text]="true" icon="pi pi-times"
                                                (onClick)="supprimerFavori(favori.favoriId)" />
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td class="flex justify-content-center p-2 py-6">
                                        Aucun favoris.
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </ng-template>
                </p-overlayPanel>
                <p-button class="topbar-button" (onClick)="fav.toggle($event)" icon="pi pi-heart" [text]="true"
                    pTooltip="Favoris" severity="contrast" />
            </div>
            <div>
                <p-overlayPanel #notif>
                    <ng-template pTemplate="content">
                        <div class="flex justify-content-between align-items-center mb-2 px-2">
                            <h6 class="m-0 font-bold">Notifications</h6>
                            <div class="flex gap-2">
                                <p-button label="Tout marquer comme lu" [text]="true" size="small"
                                    (onClick)="marquerToutLu()" *ngIf="unreadCount > 0" [loading]="marquerToutLuLoading" />
                                <p-button label="Effacer tout" [text]="true" severity="danger" size="small"
                                    (onClick)="effacerTout()" *ngIf="notifications.length > 0" [loading]="supprimeToutLoading"  />
                            </div>
                        </div>
                        <hr class="mt-0 mb-1">
                        <p-table [value]="notifications" [style]="{'min-width': '450px'}" scrollHeight="500px" scrollable="true">
                            <ng-template let-notification pTemplate="body">
                                <tr [ngClass]="{'unread': !notification.indLu}">
                                    <td class="flex align-items-center p-2">
                                        <i [class]="notification.icone || 'pi pi-bell'" [ngClass]="{'unread': !notification.indLu}"></i>
                                        <div (click)="naviguerNotification(notification)"
                                            class="ml-3 cursor-pointer flex-grow-1">
                                            <div [ngClass]="{'font-bold': !notification.indLu}" class="text-sm">{{notification.titre}}</div>
                                            <div class="text-xs text-secondary" style="max-width: 300px;">{{notification.description}}</div>
                                            <div class="text-xs text-secondary mt-1">{{notification.dateCreation | date: 'dd/MM/yyyy HH:mm'}}</div>
                                        </div>
                                        <div class="ml-2">
                                            <p-button severity="secondary" [text]="true" icon="pi pi-times"
                                                (onClick)="supprimerNotification(notification)" pTooltip="Supprimer" [loading]="supprimeLoading" />
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td class="flex justify-content-center p-2 py-6">
                                        Aucune notification.
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </ng-template>
                </p-overlayPanel>
                <p-button class="topbar-button" (onClick)="notif.toggle($event)" icon="pi pi-bell" pTooltip="Notifications"
                    [badge]="unreadCount > 0 ? unreadCount.toString() : null" [text]="true" severity="contrast" />
            </div>
            <div>
                <p-overlayPanel #hist>
                    <ng-template pTemplate="content">
                        <h6 class="m-0 font-bold">Historique</h6>
                        <hr class="mt-0 mb-1">
                        <p-table [value]="historiques" [style]="{'min-width': '400px'}">
                            <ng-template let-historique pTemplate="body">
                                <tr>
                                    <td class="flex align-items-center p-2">
                                        <i class="pi pi-clock"></i>
                                        <div pButton severity="secondary" [text]="true"
                                            (click)="naviguer(historique.url)" class="ml-2">{{historique.description}}
                                        </div>
                                        <div style="margin-left: auto;">
                                            <p-button severity="secondary" [text]="true" icon="pi pi-times"
                                                (onClick)="supprimerHistorique(historique.historiqueId)" />
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td class="flex justify-content-center p-2 py-6">
                                        Aucun historique.
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </ng-template>
                </p-overlayPanel>
                <p-button class="topbar-button" (onClick)="hist.toggle($event)" icon="pi pi-history" [text]="true"
                    pTooltip="Historique" severity="contrast" />
            </div>
            <div class="profile-item" [ngClass]="{'active-menuitem fadeInDown': appMain.topbarUserMenuActive}">
                <p-toast />
                <p-menu #menu [model]="userItems" [popup]="true" appendTo="body" />
                <p-button (onClick)="menu.toggle($event)" [text]="true" severity="contrast">
                    <p-avatar icon="pi pi-user" size="normal" styleClass="mr-2" shape="circle" />
                    <span>{{nomUtilisateur}}</span>
                </p-button>
            </div>
        </div>
    </div>
</div>